import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-features w-full pb-20" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-6 md:px-0" }
const _hoisted_3 = { class: "my-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-2 sm:gap-y-6 lg:grid-cols-3 lg:gap-x-8" }
const _hoisted_4 = { class: "group transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 shadow-lg" }
const _hoisted_5 = { class: "bg-white bg-opacity-70 rounded-xl pt-10 pb-10 px-6 md:px-8 group-hover:bg-opacity-100 relative transition-opacity ease-in-out duration-0" }
const _hoisted_6 = { class: "relative h-36" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "py-2 lg:py-0 text-2xl leading-6 font-poppins text-black font-bold" }
const _hoisted_10 = { class: "mt-0 max-w-xs font-poppins text-sm lg:text-base text-black h-20 lg:h-36 pb-2 lg:pb-2" }

import Title from '../../components/content/Title.vue';
import Container from '../../components/content/Container.vue';
import { CheckIcon } from '@heroicons/vue/outline';


type FeaturesData = {
  features: Array<{
    name: string,
    description: string,
    img: string,
    imghover: string
  }>,
  header: {
    headline: string,
    tagline: string
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Features',
  props: {
    features: {},
    header: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"max-w-7xl mx-auto px-6 md:px-0\" data-v-716326c4><div class=\"grid grid-cols-1 md:grid-cols-3\" data-v-716326c4><div class=\"text-left col-start-1 flex flex-col\" data-v-716326c4><p class=\"text-md text-white font-poppins tracking-widest\" data-v-716326c4>FEATURES</p><img class=\"w-1/2 -ml-1 py-2\" src=\"https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/smartliving.png\" data-v-716326c4></div><div class=\"text-left col-span-2\" data-v-716326c4><p class=\"text-md text-white font-poppins tracking-normal max-w-sm pt-6\" data-v-716326c4>Enjoy streaming, working, gaming, and connecting with loved ones, all powered effortlessly.</p></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dl", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            key: feature.name,
            class: "relative"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "absolute inset-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300",
                    src: feature.img
                  }, null, 8, _hoisted_7),
                  _createElementVNode("img", {
                    class: "absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300",
                    src: feature.imghover
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(feature.name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(feature.description), 1),
                _cache[0] || (_cache[0] = _createElementVNode("button", {
                  type: "button",
                  onclick: "javascript:document.getElementById('primary-address-search').focus()",
                  class: "shadow-sm transition duration-500 ease-in-out w-full text-center items-center justify-center px-4 py-3 md:text-md rounded-full text-black bg-transparent group-hover:bg-brand-button-hover group-hover:text-white md:text-18 md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent border border-black font-poppins text-18 group-hover:mt-4 group-hover:mb-4 hover:cursor-pointer"
                }, " Check your Address ", -1))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})